import React from 'react';
import { Authenticator } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { useTranslation } from 'react-i18next';
import { Box, Typography } from '@mui/material';

const Auth = ({ children }) => {
  const { t } = useTranslation();

  const components = {
    Header() {
      return (
        <Box textAlign="center" sx={{ mb: 2 }}>
          <img 
            src="/images/shipa-logo.svg" 
            alt="SHIPA Logo" 
            style={{ height: '80px', marginBottom: '16px' }}
          />
          <Typography variant="h5" color="primary">
            {t('auth.title')}
          </Typography>
        </Box>
      );
    }
  };

  const formFields = {
    signIn: {
      username: {
        placeholder: t('auth.email'),
      },
      password: {
        placeholder: t('auth.password'),
      }
    },
    signUp: {
      email: {
        placeholder: t('auth.email'),
        order: 1
      },
      password: {
        placeholder: t('auth.password'),
        order: 2
      },
      confirm_password: {
        placeholder: t('auth.confirmPassword'),
        order: 3
      }
    }
  };

  return (
    <Authenticator 
      components={components}
      formFields={formFields}
      hideSignUp={true}
    >
      {({ signOut, user }) => (
        <div>
          {React.cloneElement(children, { signOut, user })}
        </div>
      )}
    </Authenticator>
  );
};

export default Auth;